import React, { useState, useEffect } from 'react'

import expandLogo from '../../../assets/images/Expand Arrow1.png';

import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from "../../../reducers/common.reducer";
// import useUserData from '../../../hooks/useUserData';
import useTransactionTypeData from '../../../hooks/useTransactionTypeData';

import { getUserfundService, createUserfundService ,updateUserfundService } from '../../../services/user.service';

const BuyShare = (props) => {

    const { showBuyShare, setShowBuyShare, userId } = props;

    // const [expand, setExpand] = useState(false);
    const [expandType,setExpandType] = useState(false);
    // const [userData, setUserData] = useUserData();
    const [transferTypeData, setTransferTypeData] = useTransactionTypeData();
    const [userFund, setUserFund] = useState([]);
    const [transfer, setTransfer] = useState({ transferTypeId: '', transactionType: 'TransferType' });
    // const [follow, setFollow] = useState({ userId: '', name: 'User Name' });
    const [amount, setAmount] = useState(0);
    const [err, setErr] = useState(false)

    const dispatch = useDispatch();

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        getUserFund(signal);
    
        return () => {
            controller.abort();
        }
    },[userId]);

    // const selectUser= ( e ) => {
    //     e.stopPropagation();
    //     setExpand(!expand);
    // }

    const selectType= ( e ) => {
        e.stopPropagation();
        setExpandType(!expandType);
    }

    const handleAmountChange = (index, newAmount) => {
        setUserFund((prevFunds) => {
            return prevFunds.map((fund, i) => 
                i === index ? { ...fund, amount: Number(newAmount) } : fund
            );
        });
    };
    

    const handleClick = (key, userFund) => {
        updateByRowAction(userFund.userId, userFund.userTransferTypeId, userFund.transactionTypeId, userFund.amount);
    }

    const handleClose = () => {
        // setFollow({ userId: '', name: 'User Name' });
        setShowBuyShare(false);
        // setExpand(false);
        setExpandType(false);
        setErr(false);
    }

    const handleSave = () => {
        saveByRowAction();
    }

    const getUserFund = async (signal) => {
        dispatch(setIsLoading(true))
            try {
                const result = await getUserfundService(signal, userId);
                if(result.data) {
                    setUserFund(result.data)
                }
            }
            catch (error) {
            dispatch(
                setToastMessage({
                message: error?.response?.data?.message || error?.message,
                type: "error",
                })
            );
            }
            finally {
            dispatch(setIsLoading(false))
            }
    }

    const saveByRowAction = async () => {
        dispatch(setIsLoading(true))
  
        try {
            let result;
            result = await createUserfundService({
                // userTransferTypeId: userTransferTypeId,
                userId: userId,
                transferTypeId: transfer.transferTypeId,
                amount: parseInt(amount, 10)
            });
            if(result) {
                dispatch(
                    setToastMessage({
                        message: "Success",
                        type: "success",
                    })
                );
                setTimeout(() => {
                    window.location.reload();
                }, 2000)
                setErr(false);
            }
        }
        catch (error) {
            dispatch(
                setToastMessage({
                message: error?.response?.data?.message || error?.message,
                type: "error",
                })
            );
        }
        finally {
            dispatch(setIsLoading(false))
        }
    }

    const updateByRowAction = async (userId, userTransferTypeId, transactionTypeId, amount) => {
        dispatch(setIsLoading(true))

        console.log('auserId;', userId)
        console.log('auserTransferTypeId;', userTransferTypeId)
        console.log('atransferTypeId;', transactionTypeId)
        console.log('apayload;', amount)
  
        try {
            let result;
            result = await updateUserfundService({
                
                userId: userId,
                userTransferTypeId: userTransferTypeId,
                transferTypeId: transactionTypeId,
                amount: parseInt(amount, 10)
            });
            if(result) {
                dispatch(
                    setToastMessage({
                        message: "Success",
                        type: "success",
                    })
                );
                setTimeout(() => {
                    window.location.reload();
                }, 2000)
                setErr(false);
            }
        }
        catch (error) {
            dispatch(
                setToastMessage({
                message: error?.response?.data?.message || error?.message,
                type: "error",
                })
            );
        }
        finally {
            dispatch(setIsLoading(false))
        }
    }

    console.log(userFund)

    const totalAmount = userFund?.reduce((acc, fund) => acc + Number(fund.amount), 0).toLocaleString();

    const transferTypeDetails = userFund?.map((fund, key) => {
        return (
            <tr key={fund.transactionTypeId} className='flex'>
                <td className='text-userText text-left w-44 p-3'>{fund.transactionType}</td>
                <input 
                    type="number" 
                    className='w-40 border-b-2 border-gray-200 text-center focus:outline-none'
                    value={fund.amount}
                    onChange={(e) => handleAmountChange(key, e.target.value)} // Handle change
                />
                <button className='px-5 my-1 text-white bg-primary rounded-md' onClick={() => handleClick(key, fund)}>Edit</button>
            </tr>
        );
    });
    


    return (
        <div>
            {showBuyShare && (
                <div className="fixed inset-0 bg-textcol bg-opacity-30 backdrop-blur-sm flex justify-center items-center">
                    <div className="flex justify-center items-center w-[80%] h-[80%] bg-gray-500 rounded-sm">
                        
                        <div className='flex flex-col justify-around items-start w-[37%] h-[85%] bg-white'>
                            
                            <div className='flex flex-col items-end gap-5 mt-4 mx-10'>

                                {/* <h1 className='text-red text-xs'>တန်ဖိုးပြောင်းလဲ Update လုပ်လိုပါက လက်ရှိပြထားသော နောက်ဆုံးတန်ဖိုးကို အပေါင်းအနှုတ် ထည့်လုပ်ပေးပါ။</h1> */}
                                {userFund && 
                                    <h1 className='text-lg font-semibold'>{userFund[0]?.username}</h1>
                                }
                                {/* <div className='flex items-center justify-between bg-bgColor text-fgColor py-1 ps-4 w-[200px] cursor-pointer font-semibold rounded-sm relative'
                                    onClick={(e)=>selectUser(e)}>
                                    <div>{follow.name}</div>
                                    <img src={expandLogo} alt="Expand-logo" className='' />
                                    {
                                        expand ?
                                            <div className="bg-bgColor text-fgColor w-[200px] absolute top-[39px] left-0 cursor-pointer overflow-auto h-[200px] z-40">
                                                {
                                                    userData && userData.map((user) => (
                                                        <div key={user.userId}
                                                            className={`${user.userId != user.length ? "border-b-2 " : "border-b-0"} py-2 px-4 hover:bg-primary hover:text-rectangle transition-all duration-100 `}
                        
                                                            onClick={() => setFollow({ userId: user.userId, name: user.name })}
                                                        >
                                                            {user.name}
                                                        </div>
                                                    ))
                                                }
                                            </div> : ""
                                        }
                                    </div> */}

                                    <div className='flex items-center justify-between bg-bgColor text-fgColor py-1 ps-4 w-[200px] cursor-pointer font-semibold rounded-sm relative'
                                    onClick={(e)=>selectType(e)}>
                                    <div>{transfer.transactionType}</div>
                                    <img src={expandLogo} alt="Expand-logo" className='' />
                                    {
                                        expandType ?
                                            <div className="bg-bgColor text-fgColor w-[200px] absolute top-[39px] left-0 cursor-pointer overflow-auto h-[200px] z-20">
                                                {
                                                    transferTypeData && transferTypeData.map((transferType) => (
                                                        <div key={transferType.transactionTypeId}
                                                            className={`${transferType.transactionTypeId != transferType.length ? "border-b-2 " : "border-b-0"} py-2 px-4 hover:bg-primary hover:text-rectangle transition-all duration-100 `}
                        
                                                            onClick={() => setTransfer({ transferTypeId: transferType.transactionTypeId, transactionType: transferType.transactionType })}
                                                        >
                                                            {transferType.transactionType}
                                                        </div>
                                                    ))
                                                }
                                            </div> : ""
                                        }
                                    </div>

                                    <div>
                                        <input 
                                            type="number" 
                                            className='w-[200px] py-2 bg-bgColor border-gray-200 text-center focus:outline-none'
                                            value={amount}
                                            onChange={(e) => setAmount(e.target.value)}
                                        />
                                    </div>

                                <div className="flex justify-end items-center">
                                    <button className="w-[100px] h-[35px] mt-5 select-none text-white bg-primary rounded-md cursor-pointer" onClick={handleSave}>Save</button>
                                </div>
                                <div className="flex justify-end items-center">
                                    <button className="w-[100px] h-[35px] select-none text-white bg-primary rounded-md cursor-pointer" onClick={handleClose}>Cancel</button>
                                </div>
                            </div>
                        </div>
                        <div className='w-[64%] h-[85%] bg-white'>
                            <div className='mt-10 ml-20'>{transferTypeDetails}</div>

                            <div className='w-[70%] mt-10 h-20 text-right text-primary font-semibold'>
                                Total Amount: {totalAmount}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default BuyShare